import { useQuery } from "@tanstack/react-query";
import { type AppSummary, getAppCatalog } from "../../api/hub/apps";
export const statusLabel = (app: AppSummary) =>
  app.status === "disabled"
    ? "已停用"
    : app.sharedApprovedVersion
    ? "全员可用"
    : app.approval?.status === "rejected"
    ? "仅自己可用 · 共享被退回"
    : "仅自己可用";
export function AppMetadata({ app }: { app: AppSummary }) {
  return (
    <>
      <span
        className={`apps-status ${
          app.status === "disabled"
            ? "is-disabled"
            : app.sharedApprovedVersion
            ? "is-shared"
            : ""
        }`}
      >
        {statusLabel(app)}
      </span>
      <span>
        {app.privateCurrentVersion
          ? `作者当前 v${app.privateCurrentVersion}`
          : `运行 v${app.version}`}
        {app.sharedApprovedVersion
          ? ` · 全员 v${app.sharedApprovedVersion}`
          : ""}
      </span>
      {app.approval?.status === "pending" && (
        <span className="apps-pending">
          候选 v{app.approval.version} 待审批 ·{" "}
          {app.approval.method === "feishu" ? "飞书审批" : "CEO 网页审批"}
        </span>
      )}
      {app.approval?.status === "rejected" && (
        <span>候选 v{app.approval.version} 已退回；作者可发布修订版</span>
      )}
    </>
  );
}
export function AppScope({ app }: { app: AppSummary }) {
  const catalog = useQuery({
    queryKey: ["hub", "apps", "catalog"],
    queryFn: getAppCatalog,
  });
  return (
    <>
      <span className="apps-meta">以下申请范围对应第 {app.version} 版</span>
      <span>
        可读：{app.manifest.tools.map((name) => {
          const tool = catalog.data?.find((t) => t.name === name);
          return tool ? `${tool.title ?? name}（${tool.sensitivity}）` : name;
        }).join("、") || "无业务数据"}
      </span>
      <span>
        外联：{[
          ...app.manifest.csp.connectDomains,
          ...app.manifest.csp.resourceDomains,
        ].join("、") || "无"}
      </span>
      <span>设备权限：{app.manifest.permissions.join("、") || "无"}</span>
    </>
  );
}
